import { useEffect } from "react";
import "./App.css";
import AppRoutes from "./routes/AppRoutes";

function App() {
    // Aplica o tema salvo assim que o app carrega
    useEffect(() => {
        const savedTheme = localStorage.getItem("viniHubTheme") || "dark";
        document.documentElement.setAttribute("data-theme", savedTheme);
    }, []);

    return <AppRoutes />;
}

export default App;